<div class="slds-modal__header">
    <ng-content></ng-content>
  </div>
